
const m = window.require("truth-helpers/helpers/gte");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
